import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    width: 100%;
    min-height: 100%;
    font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-weight: 600;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #FFFFFF;
    color: #1E2A32;
    touch-action: pan-x pan-y;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    overscroll-behavior: none;
  }

  html {
    height: -webkit-fill-available;
  }
  body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }

  #root {
    position: relative;
    background-color: #F5F5F0;
    min-height: 100vh;
    max-width: 480px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }

  #root[data-admin="true"] {
    max-width: 100%;
    box-shadow: none;
    background-color: #2C3640;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    font-family: inherit;
  }

  input, textarea {
    font-family: inherit;
    outline: none;
    scroll-margin-bottom: 200px;
    font-size: 16px !important;
  }

  select {
    font-family: inherit;
    outline: none;
    font-size: 13px;
    font-weight: 400;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

export default GlobalStyle;
